module.exports = __webpack_public_path__ + "0af5d249/img/splash-icon.07a7c465.svg";